// extracted by mini-css-extract-plugin
export default {"allDesignsPage":"AllDesigns_allDesignsPage__FpdwV","allDesignsContainer":"AllDesigns_allDesignsContainer__Lflt4"};